import {
  GET_BUSINESS,
  GET_BUSINESS_SUCCESS,
  GET_BUSINESS_CLEAN,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  business: undefined,
}

const BusinessGet = (state = initialState, action) => {
  switch (action.type) {
    case GET_BUSINESS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_BUSINESS_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        business: action.payload.business,
      }
      break
    case GET_BUSINESS_CLEAN:
      state = initialState
      break
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default BusinessGet
